import { render, staticRenderFns } from "./TrenCard.vue?vue&type=template&id=19e82ca6&scoped=true&"
import script from "./TrenCard.vue?vue&type=script&lang=js&"
export * from "./TrenCard.vue?vue&type=script&lang=js&"
import style0 from "./TrenCard.vue?vue&type=style&index=0&id=19e82ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e82ca6",
  null
  
)

export default component.exports